export default "__VITE_ASSET__18e25812__"